/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VisibleInSchedule/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function VisibleInSchedule({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note/Read/VisibleInSchedule"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentNoteVisibleInScheduleValueData = fromData.useDataValue({ viewPath,
context: 'appointment_note',
path: 'visible_in_schedule',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: appointmentNoteVisibleInScheduleValueData,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="VisibleInSchedule.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-GPtT5': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}